import { BirdviewCard } from '../BirdviewCard'
import { BirdviewHomeRow } from '../BirdviewHomeRow'

function BirdviewHomeWidget({ dragHandleProps, section, title }) {
  return (
    <BirdviewCard
      dragHandleProps={dragHandleProps}
      state={section.state}
      title={title}
      onRetry={section.reload}
    >
      {section.items.map(item => (
        <BirdviewHomeRow item={item} key={item.id} />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewHomeWidget
